import { http } from '../utils/http';
import { log } from '../utils/common';

async function getNewsList(searchText, pageSize, currentPage) {
  try {
    const params = {
      exposureArea: 'BOTALAB',
      title: searchText,
      pageNumber: currentPage,
      pageSize,
    };
    log('newsApi::getNewsList', ` ${searchText} :: ${pageSize} :: ${currentPage}`);
    const { data } = await http.get('/news', params);

    return data;
  } catch (e) {
    return {
      error: e,
    };
  }
}

async function getNewsDetail(newsId) {
  try {
    log('newsApi::getNewsDetail', `${newsId}`);
    return await http.get(`/news/${newsId}?exposureArea=BOTALAB`);
  } catch (e) {
    return {
      error: e,
    };
  }
}
export default {
  getNewsList,
  getNewsDetail,
};
